// Autosave validation rules, shared by the edit surfaces.
//
// These mirror the throw-based backstops in Database.mjs (updateTask's
// "Name required", saveEditedItem's name check, ...) so an invalid
// intermediate state -- e.g. a name the user cleared while retyping it -- is
// HELD by useAutosave (inline field error, nothing enqueued) instead of being
// sent to the server and bounced. The Database throws remain as the backstop
// for anything that slips through.
//
// Contract (useAutosave's `validate` prop):
//   (formState) => { ok: true } | { ok: false, fieldErrors: { key: message } }

import { trimmedStringOrNull } from '../fleet-shared/Common.mjs';

export function validateRequiredName(state, message = 'Name is required.') {
  if (trimmedStringOrNull(state ? state.name : null) == null) {
    return { ok: false, fieldErrors: { name: message } };
  }
  return { ok: true };
}

// Items: name required, plus the due-soon window. A blank window means the
// default and is fine; a typed value must be a whole number of days >= 1 and
// a counter amount > 0. `min` on the number input only sets the spinner's
// floor, and TaskBuckets.soonThresholds reads 0 / negative as "unset" -- so
// without this a typed 0 would silently become 30 with nothing saying so.
export function validateItem(state) {
  const base = validateRequiredName(state);
  const fieldErrors = base.ok ? {} : { ...base.fieldErrors };
  const days = state ? state.soonDays : null;
  if (days != null && !(Number.isInteger(Number(days)) && Number(days) >= 1)) {
    fieldErrors.soonDays = 'Due Soon (days) must be a whole number of days, 1 or more. Leave it blank for the default.';
  }
  const counter = state ? state.soonCounter : null;
  if (counter != null && !(Number.isFinite(Number(counter)) && Number(counter) > 0)) {
    fieldErrors.soonCounter = 'Due Soon (counter) must be greater than 0. Leave it blank for the default.';
  }
  return Object.keys(fieldErrors).length > 0 ? { ok: false, fieldErrors } : { ok: true };
}

// Tasks: moved to fleet-shared and re-exported here, so every existing caller
// is unchanged. TaskPogoShareTasksWrite applies the same function to a
// visitor's edit; see that module's header for why there may only be one copy.
export { validateTask } from '../fleet-shared/TaskValidation.mjs';
